export default "__VITE_ASSET__DWSlPFy1__"